/* Saltylines — UX layer (ver sl-ux.css y snippets/sl-ux.liquid) */
(function () {
  'use strict';

  var cfg = window.slUx || {};
  var doc = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }
  function storageRemove(key) {
    try { window.localStorage.removeItem(key); } catch (e) {}
  }
  function sessionGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function sessionSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) {}
  }
  function cookieGet(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function cookieSet(name, value, maxAge) {
    try {
      document.cookie = name + '=' + encodeURIComponent(value) +
        ';path=/;max-age=' + maxAge + ';SameSite=Lax' +
        (window.location.protocol === 'https:' ? ';Secure' : '');
    } catch (e) {}
  }
  function track(event, params) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event };
    for (var k in params) payload[k] = params[k];
    window.dataLayer.push(payload);
  }

  /* ---------- Modo oscuro ---------- */
  function applyTheme(theme, animate) {
    if (animate && !reduceMotion) {
      doc.classList.add('sl-theme-anim');
      window.setTimeout(function () { doc.classList.remove('sl-theme-anim'); }, 380);
    }
    doc.setAttribute('data-theme', theme);
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', theme === 'dark' ? '#1C1515' : '#FFF8F1');
    document.querySelectorAll('[data-sl-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
      btn.setAttribute('data-ga-label', theme === 'dark' ? 'modo-claro' : 'modo-oscuro');
    });
  }
  applyTheme(doc.getAttribute('data-theme') === 'dark' ? 'dark' : 'light', false);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sl-theme-toggle]');
    if (!btn) return;
    var next = doc.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    applyTheme(next, true);
    storageSet('sl-theme', next);
  });

  /* ---------- Scroll: barra de progreso + volver arriba ---------- */
  var progress = document.querySelector('.sl-progress');
  var totop = document.querySelector('.sl-totop');
  var ring = totop && totop.querySelector('.sl-totop__bar');
  var RING = 125.66;
  var ticking = false;

  function onScroll() {
    var max = doc.scrollHeight - window.innerHeight;
    var ratio = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
    if (progress) progress.style.transform = 'scaleX(' + ratio + ')';
    if (totop) {
      totop.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.8);
      if (ring) ring.style.strokeDashoffset = String(RING * (1 - ratio));
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  if (totop) {
    totop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      var skip = document.querySelector('.skip-to-content-link');
      var header = document.querySelector('.sl-header__logo');
      if (header) header.focus({ preventScroll: true });
      else if (skip) skip.focus({ preventScroll: true });
    });
  }

  /* ---------- CTA móvil: marca el body para desplazar flotantes ---------- */
  if (document.querySelector('.sl-mcta')) document.body.classList.add('sl-has-mcta');

  /* ---------- Reveal on scroll ---------- */
  if (cfg.reveal && !reduceMotion && !designMode && 'IntersectionObserver' in window) {
    var targets = [];
    var sections = document.querySelectorAll('#MainContent > .shopify-section, .shopify-section-group-footer-group');
    sections.forEach(function (section, i) {
      if (i === 0) return;
      // Secciones sin altura (barras fijas como sl-sticky-atc): un transform/opacity en el
      // contenedor rompería su position: fixed
      if (section.offsetHeight < 2 || section.querySelector('.sl-sticky-atc')) return;
      var grid = section.querySelector('.sl-grid, .product-grid');
      if (grid) {
        Array.prototype.forEach.call(grid.children, function (card, j) {
          card.style.setProperty('--sl-reveal-delay', (j % 4) * 70 + 'ms');
          targets.push(card);
        });
      } else {
        targets.push(section);
      }
    });
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) {
      // Solo lo que está por debajo del primer pantallazo: nada visible se oculta (sin CLS ni LCP tardío)
      if (el.getBoundingClientRect().top < vh) return;
      el.classList.add('sl-reveal');
      io.observe(el);
    });
  }

  /* ---------- Imágenes diferidas: shimmer + fundido ---------- */
  if (!designMode) {
    var vh2 = window.innerHeight;
    document.querySelectorAll('#MainContent img[loading="lazy"]').forEach(function (img) {
      if (img.complete || img.getBoundingClientRect().top < vh2) return;
      var box = img.parentElement;
      if (!box) return;
      img.classList.add('sl-img-fade');
      box.classList.add('sl-img-wait');
      var done = function () { box.classList.remove('sl-img-wait'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  /* ---------- Microinteracciones: ripple en botones ---------- */
  if (!reduceMotion) {
    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest('.sl-btn');
      if (!btn) return;
      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height) * 2;
      var dot = document.createElement('span');
      dot.className = 'sl-ripple';
      dot.style.width = dot.style.height = size + 'px';
      dot.style.left = (e.clientX - rect.left - size / 2) + 'px';
      dot.style.top = (e.clientY - rect.top - size / 2) + 'px';
      btn.appendChild(dot);
      dot.addEventListener('animationend', function () { dot.remove(); });
    });
  }

  /* ---------- Microinteracciones: cursor ---------- */
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (cfg.cursor && finePointer && !reduceMotion && !designMode) {
    var cursor = document.createElement('div');
    cursor.className = 'sl-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cursor);
    var x = -100, y = -100, cx = -100, cy = -100, running = false;
    var HOVER = 'a, button, [role="button"], label, select, summary, .sl-pc';
    var loop = function () {
      cx += (x - cx) * 0.22;
      cy += (y - cy) * 0.22;
      cursor.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)';
      if (Math.abs(x - cx) > 0.2 || Math.abs(y - cy) > 0.2) window.requestAnimationFrame(loop);
      else running = false;
    };
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      cursor.classList.add('is-active');
      var over = e.target.closest && e.target.closest(HOVER);
      var typing = e.target.closest && e.target.closest('input, textarea, iframe, [contenteditable]');
      cursor.classList.toggle('is-hover', !!over && !typing);
      if (typing) cursor.classList.remove('is-active');
      if (!running) { running = true; window.requestAnimationFrame(loop); }
    }, { passive: true });
    document.addEventListener('pointerdown', function () { cursor.classList.add('is-down'); });
    document.addEventListener('pointerup', function () { cursor.classList.remove('is-down'); });
    document.documentElement.addEventListener('mouseleave', function () { cursor.classList.remove('is-active'); });
  }

  /* ---------- Carga: barra de navegación entre páginas ---------- */
  var navload = document.querySelector('.sl-navload');
  if (navload) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      navload.classList.remove('is-loading');
      void navload.offsetWidth;
      navload.classList.add('is-loading');
    });
    window.addEventListener('pageshow', function () { navload.classList.remove('is-loading'); });
  }

  /* ---------- Carga: estado en envío de formulario de producto ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var btn = form.querySelector('[type="submit"].sl-btn');
    if (!btn) return;
    btn.classList.add('is-loading');
    window.setTimeout(function () { btn.classList.remove('is-loading'); }, 2500);
  });

  /* ---------- Banner de cookies (Shopify Customer Privacy API) ---------- */
  var banner = document.querySelector('.sl-cookie');
  if (banner && !designMode) {
    var KEY = 'sl-cookie-choice';       // localStorage: solo guarda 'accept'
    var COOKIE = 'sl_cookie_consent';   // cookie propia: respaldo si se borra localStorage
    var SESSION_KEY = 'sl-cookie-ask';  // sessionStorage: silencia el banner tras rechazar
    var MAX_AGE = 60 * 60 * 24 * 400;   // 400 días: máximo que aceptan los navegadores

    var withPrivacy = function (cb) {
      if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          cb(err ? null : window.Shopify.customerPrivacy);
        });
      } else {
        cb(null);
      }
    };

    // Solo el "aceptar" se recuerda. Un rechazo nunca se persiste: se vuelve a preguntar.
    var hasAccepted = function (cp) {
      if (storageGet(KEY) === 'accept' || cookieGet(COOKIE) === 'accept') return true;
      if (!cp || typeof cp.currentVisitorConsent !== 'function') return false;
      var c = cp.currentVisitorConsent() || {};
      return ['analytics', 'marketing', 'preferences'].some(function (k) { return c[k] === 'yes'; });
    };

    var show = function () {
      banner.hidden = false;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { banner.classList.add('is-visible'); });
      });
    };
    var hide = function () {
      banner.classList.remove('is-visible');
      window.setTimeout(function () { banner.hidden = true; }, 450);
    };

    var decide = function (granted) {
      var value = granted ? 'accept' : 'reject';
      if (granted) {
        storageSet(KEY, value);
        cookieSet(COOKIE, value, MAX_AGE);
      } else {
        // Rechazo: no se guarda nada duradero, solo se calla durante esta sesión.
        storageRemove(KEY);
        cookieSet(COOKIE, '', 0);
        sessionSet(SESSION_KEY, 'reject');
      }
      withPrivacy(function (cp) {
        if (cp && typeof cp.setTrackingConsent === 'function') {
          cp.setTrackingConsent({ analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted }, function () {});
        }
      });
      var state = granted ? 'granted' : 'denied';
      window.dataLayer = window.dataLayer || [];
      // Consent Mode v2: gtag() empuja el objeto arguments, que es lo que GTM interpreta
      (function gtag() { window.dataLayer.push(arguments); })('consent', 'update', {
        ad_storage: state, analytics_storage: state, ad_user_data: state, ad_personalization: state
      });
      track('cookie_consent', { consent_choice: value });
      hide();
    };

    banner.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sl-cookie]');
      if (!btn) return;
      decide(btn.getAttribute('data-sl-cookie') === 'accept');
    });

    // Limpia el 'reject' que guardaban versiones anteriores para volver a preguntar.
    if (storageGet(KEY) === 'reject') storageRemove(KEY);

    withPrivacy(function (cp) {
      if (hasAccepted(cp)) {
        // Renueva la cookie en cada visita para estirar al máximo la caducidad.
        cookieSet(COOKIE, 'accept', MAX_AGE);
        storageSet(KEY, 'accept');
        return;
      }
      if (sessionGet(SESSION_KEY)) return;
      window.setTimeout(show, 1200);
    });
  }
})();
